<template>
<!--              Todo: Enable cookie policy-->
<!--              <span class="pointer adjustText" @click="showCookieManager">Adjust Cookie & Policy Settings</span>-->

  <section id="Footer" class="pt-4 pb-1">
    <b-container>
      <b-row class="pt-4">

        <!------------------------ ER LOGO ------------------------>
        <b-col lg="3" md="3" sm="12" class="text-left">
          <img class="footerLogo" src="../assets/logo/easyRemessa-logo.png" alt="" />

          <div class="mt-2 d-flex flex-md-column flex-lg-row">
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.easyremessa">
              <img id="android" class="android-store zoom-in" :src="require(`../assets/app_store/googlestore-${getLanguage}.png`)" alt="Google Play Store" />
            </a>

            <a target="_blank" href="https://apps.apple.com/es/app/easyremessa-by-yvoe-france/id1521872811?platform=iphone">
              <img id="test" class="ios-store zoom-in" :src="require(`../assets/app_store/appstore-${getLanguage}.png`)" alt="AppStore Icon" />
            </a>
          </div>
        </b-col>


        <!------------------------ About & Legal ------------------------>
        <b-col lg="2" md="2" sm="12" class="px-lg-4">
          <h5 class="pt-3 mb-3 text-left">{{ $t("footer.about.about") }}</h5>
          <div class="linkBox text-left">
            <ul class="list-unstyled linkList">
              <li>
                <router-link to="/about">{{ $t("footer.about.about_us") }}</router-link>
              </li>
              <li>
                <router-link to="/contact">{{ $t("footer.about.contact_us") }}</router-link>
              </li>
            </ul>
          </div>
        </b-col>

        <b-col lg="3" md="3" sm="12" class="px-lg-5">
          <h5 class="pt-3 mb-3 text-left">{{ $t("footer.legal.legal") }}</h5>
          <div class="linkBox text-left">
            <ul class="list-unstyled linkList">
              <li>
                <router-link to="/privacy_policy">{{ $t("footer.legal.privacy") }}</router-link>
              </li>
              <li>
                <router-link to="/terms_and_conditions">{{ $t("footer.legal.terms") }}</router-link>
              </li>
              <li>
                <router-link to="/gdpr_policy">{{ $t("footer.legal.gdpr") }}</router-link>
              </li>
            </ul>
          </div>
        </b-col>

        <!------------------------ Contact Us ------------------------>
        <b-col lg="4" md="4" sm="12" class="pl-lg-5">
          <h5 class="pt-3 mb-3 text-left contactUs">{{ $t("footer.about.contact_us") }}</h5>
          <div class="footerContact">
            <p class="lead text-left pl-2">
              <!--              <strong><small>Contact Us</small></strong><br>-->
              <small class="whitespace-nowrap"><i class="fal fa-envelope pr-2"></i>remittent@easyremessa.com</small> <br />
              <small><i class="fal fa-phone mr-1"></i> +33 6 12 57 65 41</small><br />

              <small><i class="fal fa-clock mr-2"></i> Monday - Friday: 09.00 - 19.00</small>
            </p>

            <hr class="hr" />

            <p class="lead text-left pl-2">
              <!--              <strong><small>Beneficiary Contact</small></strong><br>-->
              <small class="whitespace-nowrap"><i class="fal fa-envelope pr-2"></i>beneficiary@easyremessa.com</small> <br />
              <small><i class="fal fa-phone mr-1"></i> +33 6 12 57 65 41</small><br />
              <small><i class="fal fa-clock mr-2"></i>Monday - Friday: 08.00 - 20.00</small>
            </p>
          </div>
        </b-col>


      </b-row>


    </b-container>
  </section>
</template>

<script>
export default {
  name: "Footer",
  props: {},
  methods: {
    showCookieManager() {
      this.$store.dispatch("SetCookieModalDisplay", true);
    }
  },
  computed: {
    getLanguage() {
      return this.$store.getters.GetActiveLanguage;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#Footer {
  min-height: 350px;
  line-height: 30px;
}

.adjustText {
  font-weight: 500;
  font-size: 0.9em;
}

.footerLogo {
  width: 255px;
  transform: translateY(-10%);
}

.linkList li a {
  color: #031302;
  position: relative;

  &:hover {
    color: #33a544;
  }

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    border-radius: 2px;
    background-color: #33a544;
    bottom: -2px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 300ms ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
}

.android-store {
  width: 115px;
  margin: 10px 5px 10px 0;
  transition: 0.4s;
}

.ios-store {
  width: 115px;
  margin: 10px 5px;
  transition: 0.4s;
}

.android-store:hover, .ios-store:hover {
  filter: brightness(1.5);
  transform: translateY(-2px);
}

.footerContact p {
  color: #031302;
  /*font-size: 1.3em;*/
}

.hr {
  border: 1px solid #d3c34f6c;
  padding: 0 !important;
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.whitespace-nowrap {
  white-space: nowrap;
}

@media screen and (max-width: 992px){
  .footerLogo {
    width: 155px;
    margin-top: 0.6rem;
  }

  .ios-store {
    margin: 0;
  }
}

@media screen and (max-width: 768px){
  .footerLogo {
    width: 13.75rem;
  }
  .ios-store {
    margin: 10px 5px;
  }
}

</style>
